'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: ["currentFarm"],

    data: function data() {
        return {
            time: 0
        };
    },
    mounted: function mounted() {
        _momentTimezone2.default.locale(window.GLOBAL_CONFIG.lang);
        this.updatetTime();
        setInterval(this.updatetTime.bind(this), 1000);
    },


    methods: {
        updatetTime: function updatetTime() {
            var timezone = this.currentFarm.config.location.timezone ? this.currentFarm.config.location.timezone : 'Europe/Paris';
            this.time = (0, _momentTimezone2.default)().tz(timezone).format('LT');
        }
    }

}; //
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/infos/timer/TimerComponent.vue
// module id = 398
// module chunks = 0